import { el, showToast, t } from './dom';
import { api, ApiError } from './api';
import type { User } from './types';
import { buildLanguageSelector } from './languageSelector';
import { COMPANY } from './config/company';

export function renderLogin(root: HTMLElement, onSuccess: (user: User, accessToken: string) => void) {
  root.replaceChildren();

  const container = el('div', { className: 'login-container' });
  const card = el('div', { className: 'login-card' });

  // Selector de idioma arriba a la derecha
  const langWrapper = el('div', { className: 'login-lang-wrapper' });
  langWrapper.appendChild(buildLanguageSelector(() => {
    renderLogin(root, onSuccess);
  }));
  card.appendChild(langWrapper);

  // Logo grande centrado
  const logo = document.createElement('img');
  logo.src = COMPANY.logoUrl;
  logo.alt = COMPANY.name;
  logo.className = 'login-logo';
  card.appendChild(logo);

  // Título
  card.appendChild(el('h2', { text: COMPANY.name }));
  card.appendChild(el('p', {
    className: 'login-subtitle',
    text: t('login.title'),
  }));

  // Form
  const form = el('form');
  form.addEventListener('submit', (e) => e.preventDefault());

  const emailGroup = el('div', { className: 'form-group' });
  emailGroup.appendChild(el('label', { text: t('login.email'), attrs: { for: 'email' } }));
  const emailInput = document.createElement('input');
  emailInput.type = 'email';
  emailInput.id = 'email';
  emailInput.required = true;
  emailInput.autocomplete = 'username';
  emailInput.placeholder = 'usuario@empresa.com';
  emailGroup.appendChild(emailInput);

  const passwordGroup = el('div', { className: 'form-group' });
  passwordGroup.appendChild(el('label', { text: t('login.password'), attrs: { for: 'password' } }));
  const passwordInput = document.createElement('input');
  passwordInput.type = 'password';
  passwordInput.id = 'password';
  passwordInput.required = true;
  passwordInput.autocomplete = 'current-password';
  passwordGroup.appendChild(passwordInput);

  const submitBtn = el('button', {
    className: 'btn btn-primary btn-block',
    text: t('login.submit'),
    attrs: { type: 'submit' },
  });

  const helpText = el('p', {
    className: 'login-help',
    text: t('login.helpText'),
  });

  form.append(emailGroup, passwordGroup, submitBtn);

  const handleLogin = async () => {
    const email = emailInput.value.trim();
    const password = passwordInput.value;
    if (!email || !password) {
      showToast(t('login.fillFields'), 'error');
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = t('login.loading');

    try {
      const result = await api.request<{ user: User; accessToken: string; deviceId: string }>(
        'POST',
        '/auth/login',
        { email, password, deviceId: api.getDeviceId() },
        { skipAuth: true },
      );
      api.setAccessToken(result.accessToken);
      showToast(t('login.welcome'), 'success');
      onSuccess(result.user, result.accessToken);
    } catch (e) {
      const msg = e instanceof ApiError ? e.message : t('common.unknownError');
      showToast(msg, 'error');
      submitBtn.disabled = false;
      submitBtn.textContent = t('login.submit');
    }
  };

  submitBtn.addEventListener('click', handleLogin);
  passwordInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') handleLogin();
  });

  card.append(form, helpText);
  container.appendChild(card);
  root.appendChild(container);
}
